import React, { useState } from "react"
import classnames from "@utils/classnames"
import Section from "@components/section"
import Title from "@components/title"
import Slider from "@components/slider"
import Modal from "@components/modal"
import ModalSection from "@components/modalSection"
import FrameLogos from "@components/frameLogos"
import Logos from "@components/logos"
import ColTitle from "@components/colTitle"
import styles from "./playable.module.scss"

import game1Img from "@images/playable/1.png"
import game2Img from "@images/playable/2.png"
import game3Img from "@images/playable/3.png"

import collect3Img from "@images/logos/collect-3.png"
import collect4Img from "@images/logos/collect-4.png"
import collect6Img from "@images/logos/collect-6.png"

const renderItem = (title, en, img) => {
  return (
    <div className={styles.item}>
      <ColTitle sub={en}>{title}</ColTitle>
      <img src={img} alt={title} className="fluidImg" />
    </div>
  )
}

const ModalBody = ({ closeModal }) => {
  return (
    <Slider
      data={[0]}
      renderItem={() => {
        return (
          <ModalSection title="游戏列表">
            <Logos
              total={78}
              urlPrefix="https://site.gcores.com/assets/fusion2021/collect/collect"
            />
          </ModalSection>
        )
      }}
      onClose={closeModal}
    />
  )
}

const Playable = React.memo(props => {
  const [gamesVisible, setGamesVisible] = useState(false)
  const closeModal = () => {
    setGamesVisible(false)
  }
  return (
    <Section id="block-playable">
      <Modal isOpen={gamesVisible} onRequestClose={closeModal}>
        <ModalBody closeModal={closeModal} />
      </Modal>
      <Title>
        在核聚变现场
        <br />
        体验全新的线上、线下游戏挑战
      </Title>
      <div className={styles.items}>
        {renderItem("独立小游戏", "MINI GAMES", game1Img)}
        {renderItem("实景冒险装置", "ARTISTIC INSTALLATION", game2Img)}
        {renderItem("互动解密", "ARG PUZZLE", game3Img)}
      </div>
      <FrameLogos
        title="玩游戏，集卡牌"
        sub="Collectible Cards"
        desc="游玩这些游戏可随机获得故事设定卡"
        logos={[collect3Img, collect4Img, collect6Img]}
        onClick={() => {
          setGamesVisible(true)
        }}
      />
    </Section>
  )
})

Playable.displayName = "Playable"
export default Playable
